import React from 'react';
import styles from './ProgressBarStyleSelector.module.scss';

interface ProgressBarStyleSelectorProps {
    value: string;
    onChange: (property: string, value: string) => void;
    property: string;
    progressBarColor?: string;
    progressBarBackgroundColor?: string;
    progressBarHeight?: number;
}

const Index: React.FC<ProgressBarStyleSelectorProps> = ({
                                                            value,
                                                            onChange,
                                                            property,
                                                            progressBarColor = '#fc0',
                                                            progressBarBackgroundColor = '#2d2d2d',
                                                            progressBarHeight = 4
                                                        }) => {
    const styleOptions = [
        {
            value: 'bar',
            label: 'Bar',
            preview: 'bar'
        },
        {
            value: 'numbered',
            label: 'Mit Schritt-Nummern',
            preview: 'numbered'
        },
        {
            value: 'dots',
            label: 'Punkte-Stil',
            preview: 'dots'
        },
        {
            value: 'minimal',
            label: 'Minimal',
            preview: 'minimal'
        }
    ];

    const renderPreview = (previewType: string) => {
        const activeColor = progressBarColor;
        const bgColor = progressBarBackgroundColor;
        const barHeight = progressBarHeight || 4;
        switch (previewType) {
            case 'bar':
                return (
                    <div className={styles.barPreview}>
                        <div
                            className={styles.barTrack}
                            style={{
                                backgroundColor: bgColor,
                                height: `${barHeight}px`
                            }}

                        >
                            <div
                                className={styles.barFill}
                                style={{
                                    backgroundColor: activeColor,
                                    height: `${barHeight}px`,
                                }}
                            />
                        </div>
                    </div>
                );

            case 'numbered':
                return (
                    <div className={styles.numberedPreview}>
                        <div className={styles.stepContainer}>
                            <div
                                className={`${styles.numberedStep} ${styles.active}`}
                                style={{
                                    backgroundColor: activeColor,
                                    borderColor: activeColor,
                                    color: '#fff'
                                }}
                            >
                                1
                            </div>
                            <div
                                className={styles.previewLine}
                                style={{backgroundColor: activeColor}}
                            />
                        </div>
                        <div className={styles.stepContainer}>
                            <div
                                className={`${styles.numberedStep} ${styles.active}`}
                                style={{
                                    backgroundColor: activeColor,
                                    borderColor: activeColor,
                                    color: '#fff'
                                }}
                            >
                                2
                            </div>
                            <div
                                className={styles.previewLine}
                                style={{backgroundColor: bgColor}}
                            />
                        </div>
                        <div className={styles.stepContainer}>
                            <div
                                className={styles.numberedStep}
                                style={{
                                    backgroundColor: bgColor,
                                    borderColor: bgColor,
                                    color: '#666'
                                }}
                            >
                                3
                            </div>
                        </div>
                    </div>
                );

            case 'dots':
                return (
                    <div className={styles.dotsPreview}>
                        <div
                            className={`${styles.dot} ${styles.active}`}
                            style={{
                                backgroundColor: activeColor,
                                width: `${barHeight}px`,
                                height: `${barHeight}px`
                            }}

                        />
                        <div
                            className={`${styles.dot} ${styles.active}`}
                            style={{
                                backgroundColor: activeColor,
                                width: `${barHeight}px`,
                                height: `${barHeight}px`
                            }}
                        />
                        <div
                            className={styles.dot}
                            style={{backgroundColor: bgColor,
                                width: `${barHeight}px`,
                                height: `${barHeight}px`
                        }}
                        />
                    </div>
                );

            case 'minimal':
                return (
                    <div className={styles.minimalPreview}>
            <span
                className={styles.currentNumber}
                style={{color: activeColor}}
            >
              2
            </span>
                        <span className={styles.separator}>/</span>
                        <span className={styles.totalNumber}>3</span>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className={styles.styleSelectorContainer}>
            <label className={styles.label}>Progress Bar Stil</label>
            <div className={styles.optionsGrid}>
                {styleOptions.map((option) => (
                    <div
                        key={option.value}
                        className={`${styles.styleOption} ${value === option.value ? styles.selected : ''}`}
                        onClick={() => onChange(property, option.value)}
                    >
                        <div className={styles.previewContainer}>
                            {renderPreview(option.preview)}
                        </div>
                        <div className={styles.optionLabel}>
                            {option.label}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Index;